import React, { useState, createContext } from 'react';
import uniqBy from 'lodash.uniqby';

const PhotoSelector = createContext(null);

const PhotoSelectorContextProvider = ({ children }) => {
  const initialSelectionSettings = {
    showFileNames: false,
    isSelectAll: false,
  };
  const [selectedPhotos, setSelectedPhotos] = useState([]);
  const [selectionEnabled, setSelectionEnabled] = useState(false);
  const [selectionSettings, setSelectionSettings] = useState(
    initialSelectionSettings,
  );

  const onResetSelection = () => {
    setSelectionEnabled(false);
    setSelectedPhotos([]);
    setSelectionSettings(initialSelectionSettings);
  };

  const onToggleSelectionEnabled = () => {
    setSelectionEnabled(prev => !prev);
  };

  const onSelectPhotos = photoIds => {
    setSelectedPhotos(prev => uniqBy([...prev, ...photoIds]));
  };

  const onDeselectPhotos = photoIds => {
    setSelectedPhotos(prev =>
      prev.filter(photoId => !photoIds.includes(photoId)),
    );
  };

  const onSelectAll = () => {
    setSelectionSettings({
      ...selectionSettings,
      isSelectAll: true,
    });
    setSelectedPhotos([]);
  };

  return (
    <PhotoSelector.Provider
      value={{
        selectedPhotos,
        selectionSettings,
        setSelectionSettings,
        selectionEnabled,
        onResetSelection,
        onToggleSelectionEnabled,
        onSelectPhotos,
        onDeselectPhotos,
        onSelectAll,
      }}
    >
      {children}
    </PhotoSelector.Provider>
  );
};

export { PhotoSelectorContextProvider, PhotoSelector };
